var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.9898 6.92847L9 6.92868L9.0102 6.92847C9.39335 6.92065 9.75817 6.76295 10.0264 6.48921C10.2946 6.21548 10.4448 5.84752 10.4448 5.46429C10.4448 5.08106 10.2946 4.7131 10.0264 4.43936C9.75817 4.16562 9.39335 4.00793 9.0102 4.0001L9 3.9999L8.9898 4.0001C8.60664 4.00793 8.24183 4.16562 7.97362 4.43936L8.33076 4.78929L7.97362 4.43936C7.70542 4.7131 7.5552 5.08106 7.5552 5.46429C7.5552 5.84752 7.70542 6.21548 7.97362 6.48921L8.33076 6.13929L7.97362 6.48921C8.24183 6.76295 8.60664 6.92065 8.9898 6.92847ZM0.5 9C0.5 4.30605 4.30605 0.5 9 0.5C13.6939 0.5 17.5 4.30605 17.5 9C17.5 13.6939 13.6939 17.5 9 17.5C4.30605 17.5 0.5 13.6939 0.5 9ZM9.48214 14C9.84668 14 10.1429 13.7038 10.1429 13.3393V7.875C10.1429 7.51047 9.84668 7.21429 9.48214 7.21429H8.51786C8.15332 7.21429 7.85714 7.51046 7.85714 7.875V13.3393C7.85714 13.7038 8.15332 14 8.51786 14H9.48214Z",
    fill: "black",
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info_icon.866413f16bb557264bb1c512a8fc237d.svg";
export { ForwardRef as ReactComponent };